import styled from 'styled-components';
export const StyledLink = styled.a `
  display: inline-flex;
  color: ${({ theme }) => theme.Color.Neutrals.Dark};
  cursor: pointer;
  text-decoration: none;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  span {
    transition: all ${({ theme }) => theme.Transition.Timing.Out};
    text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  }

  &:visited {
    color: ${({ theme }) => theme.Color.Neutrals.Dark};
  }

  &:hover,
  &:focus {
    transition: all ${({ theme }) => theme.Transition.Timing.In};
    span {
      color: ${({ theme }) => theme.Color.Brand.Primary};
    }
    i {
      fill: ${({ theme }) => theme.Color.Brand.Primary};
    }
  }
`;
//# sourceMappingURL=TextLink.style.js.map